import DataFeed from './DataFeed'
import ValidationError from '../common/ValidationError'
import ReportGroup from './ReportGroup'

export default class SiteConfig {
  key: string = ""
  name: string = ""
  marketKey: string = ""
  alarmData: DataFeed = new DataFeed()
  tenMinuteData: DataFeed = new DataFeed()
  liveData: DataFeed = new DataFeed()
  solarGisEnabled: boolean = false
  liveDataHasUnsavedChanges: boolean = false
  alarmDataHasUnsavedChanges: boolean = false
  tenMinuteDataHasUnsavedChanges: boolean = false
  validation: ValidationError[] = []
  reportGroups: ReportGroup[] = []
  technology: string = ""
}

export const getGeneratorName = (technology: string) => {
  return getTechnologyString(technology, "Turbine", "Inverter", "Generator")
}

export const getTechnologyString = (technology: string, windName: string, solarName: string, defaultName: string) => {
  switch(technology)
  {
    case "Wind":
      return windName;
    case "Photovoltaic":
      return solarName;
    default:
      return defaultName;
  }
}

export const mockSiteConfig = new SiteConfig()
mockSiteConfig.key = 'foo'
mockSiteConfig.name = 'baa'
mockSiteConfig.marketKey = 'someMarketKey'
